export default "__VITE_ASSET__D8zH0PLp__"